export default [
  {
    path: "classSchedule/index",
    name: "classScheduleIndex",
    meta: {
      title: "课表",
      isShowTab: false,
    },
    component: () => import("@/views/classSchedule/index.vue"),
  },
];
